export const BuildInfo = {timestamp:1770235369000}
